$(document).ready(function(){
    // testimonial slider
    $(".testimonials-list").slick({
        dots: false,
        adaptiveHeight: true,
        arrows: true,
        infinite: false,
        nextArrow: '<div class="next_arrow_slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_436_205)"><path d="M4.25939 15.8718C4.12502 15.8718 3.9875 15.8187 3.88437 15.7156C3.67812 15.5093 3.67812 15.1718 3.88437 14.9656L10.9437 7.9062L3.9875 0.949951C3.78125 0.743701 3.78125 0.406201 3.9875 0.199951C4.19375 -0.00629902 4.53125 -0.00629902 4.7375 0.199951L12.0719 7.5312C12.2781 7.73745 12.2781 8.07495 12.0719 8.2812L4.6375 15.7156C4.53125 15.8218 4.39689 15.8718 4.25939 15.8718Z" fill="#334D80"/></g><defs><clipPath id="clip0_436_205"><rect width="16" height="16" fill="white" transform="matrix(0 -1 -1 0 16 16)"/></clipPath></defs></svg></div>',
        prevArrow: '<div class="prev_arrow_slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_436_209)"><path d="M11.7406 15.8718C11.875 15.8718 12.0125 15.8187 12.1156 15.7156C12.3219 15.5093 12.3219 15.1718 12.1156 14.9656L5.05627 7.9062L12.0125 0.949951C12.2188 0.743701 12.2188 0.406201 12.0125 0.199951C11.8063 -0.00629902 11.4688 -0.00629902 11.2625 0.199951L3.92814 7.5312C3.72189 7.73745 3.72189 8.07495 3.92814 8.2812L11.3625 15.7156C11.4688 15.8218 11.6031 15.8718 11.7406 15.8718Z" fill="#334D80"/></g><defs><clipPath id="clip0_436_209"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 749,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });



 
 
    $(".product__media-list").slick({
        dots: false,
        adaptiveHeight: true,
        arrows: true,
        infinite: false,
        nextArrow: '<div class="next_arrow_slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_436_205)"><path d="M4.25939 15.8718C4.12502 15.8718 3.9875 15.8187 3.88437 15.7156C3.67812 15.5093 3.67812 15.1718 3.88437 14.9656L10.9437 7.9062L3.9875 0.949951C3.78125 0.743701 3.78125 0.406201 3.9875 0.199951C4.19375 -0.00629902 4.53125 -0.00629902 4.7375 0.199951L12.0719 7.5312C12.2781 7.73745 12.2781 8.07495 12.0719 8.2812L4.6375 15.7156C4.53125 15.8218 4.39689 15.8718 4.25939 15.8718Z" fill="#334D80"/></g><defs><clipPath id="clip0_436_205"><rect width="16" height="16" fill="white" transform="matrix(0 -1 -1 0 16 16)"/></clipPath></defs></svg></div>',
        prevArrow: '<div class="prev_arrow_slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_436_209)"><path d="M11.7406 15.8718C11.875 15.8718 12.0125 15.8187 12.1156 15.7156C12.3219 15.5093 12.3219 15.1718 12.1156 14.9656L5.05627 7.9062L12.0125 0.949951C12.2188 0.743701 12.2188 0.406201 12.0125 0.199951C11.8063 -0.00629902 11.4688 -0.00629902 11.2625 0.199951L3.92814 7.5312C3.72189 7.73745 3.72189 8.07495 3.92814 8.2812L11.3625 15.7156C11.4688 15.8218 11.6031 15.8718 11.7406 15.8718Z" fill="#334D80"/></g><defs><clipPath id="clip0_436_209"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
        speed: 1000,
        asNavFor: '.thumbnail-list',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 749,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.thumbnail-list').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product__media-list',
        dots: false,
        arrows: false,
        focusOnSelect: true
        });


         $("ul.product-main-media").slick({
        dots: false,
        adaptiveHeight: true,
        arrows: true,
        infinite: false,
        nextArrow: '<div class="next_arrow_slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_436_205)"><path d="M4.25939 15.8718C4.12502 15.8718 3.9875 15.8187 3.88437 15.7156C3.67812 15.5093 3.67812 15.1718 3.88437 14.9656L10.9437 7.9062L3.9875 0.949951C3.78125 0.743701 3.78125 0.406201 3.9875 0.199951C4.19375 -0.00629902 4.53125 -0.00629902 4.7375 0.199951L12.0719 7.5312C12.2781 7.73745 12.2781 8.07495 12.0719 8.2812L4.6375 15.7156C4.53125 15.8218 4.39689 15.8718 4.25939 15.8718Z" fill="#334D80"/></g><defs><clipPath id="clip0_436_205"><rect width="16" height="16" fill="white" transform="matrix(0 -1 -1 0 16 16)"/></clipPath></defs></svg></div>',
        prevArrow: '<div class="prev_arrow_slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_436_209)"><path d="M11.7406 15.8718C11.875 15.8718 12.0125 15.8187 12.1156 15.7156C12.3219 15.5093 12.3219 15.1718 12.1156 14.9656L5.05627 7.9062L12.0125 0.949951C12.2188 0.743701 12.2188 0.406201 12.0125 0.199951C11.8063 -0.00629902 11.4688 -0.00629902 11.2625 0.199951L3.92814 7.5312C3.72189 7.73745 3.72189 8.07495 3.92814 8.2812L11.3625 15.7156C11.4688 15.8218 11.6031 15.8718 11.7406 15.8718Z" fill="#334D80"/></g><defs><clipPath id="clip0_436_209"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
        speed: 1000,
        asNavFor: 'ul.product-thumbnail-media',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 993,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 749,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('ul.product-thumbnail-media').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: 'ul.product-main-media',
        dots: false,
        arrows: false,
        focusOnSelect: true
        });
    // Tabbed FAQs
    

    //  Open first FAQ of active tab on load
    var firstTab = $('.faq-tabs__nav li.active').data('tab');
    var firstFaq = $('#tab-' + firstTab).find('.faq-item').first();

    if (firstFaq.length) {
        $('.faq-item').removeClass('active');
        $('.faq-answer').hide();

        firstFaq.addClass('active');
        firstFaq.find('.faq-answer').show();
    }

    //  Tab click
    $('.faq-tabs__nav li').on('click', function () {
        var tabId = $(this).data('tab');

        // Switch active tab
        $('.faq-tabs__nav li').removeClass('active');
        $(this).addClass('active');

        $('.faq-tab').removeClass('active');
        $('#tab-' + tabId).addClass('active');

        //  Reset ALL accordions globally
        $('.faq-item').removeClass('active');
        $('.faq-answer').slideUp(0);

        // Open first FAQ of selected tab
        var firstFaq = $('#tab-' + tabId).find('.faq-item').first();
        if (firstFaq.length) {
            firstFaq.addClass('active');
            firstFaq.find('.faq-answer').slideDown();
        }
    });

    //  Accordion click
    $('.faq-question').on('click', function () {
        var $this = $(this);
        var faqItem = $this.closest('.faq-item');
        var answer = $this.next('.faq-answer');

        if (faqItem.hasClass('active')) {
            // Close current
            faqItem.removeClass('active');
            answer.slideUp();
        } else {
            //  Close ALL accordions everywhere
            $('.faq-item').removeClass('active');
            $('.faq-answer').slideUp();

            // Open clicked one
            faqItem.addClass('active');
            answer.slideDown();
        }
    });


});

$(document).ready(function () {

  // Detect page type
  var isProductPage = $('body').hasClass('template-product');

  // Set wrap count
  var wrapCount = isProductPage ? 5 : 6;

  // Wrap elements
  var reference = $('variant-selects');

  var elementsToWrap = reference
    .nextAll(':lt(' + wrapCount + ')')
    .addBack();

  elementsToWrap.wrapAll('<div class="custom-boxshadow-wrapper"></div>');


  function formatMoney(cents) {
    cents = parseInt(cents || 0);
    return '$' + (cents / 100).toFixed(2);
  }

// ============================

// Custom code for Product QTY

// =============================


  function getSubscriptionSavePercent() {
    var raw = $('.subscription-toggle').first().attr('data-subscription-save-percent');
    var p = parseInt(raw, 10);
    if (isNaN(p) || p < 1) return 30;
    return p;
  }

  function getQuantitySavePercent($inp) {
    var raw = $inp.attr('data-quantity-save-percent');
    var p = parseInt(raw, 10);
    if (!isNaN(p) && p > 0) return p;
    var num = parseInt(($inp.val() || '').replace(/\D/g, ''), 10);
    if (num === 1) return 10;
    if (num === 3) return 20;
    if (num === 6) return 30;
    return 0;
  }

  function updateSubscriptionToggleLabel() {
    var pct = getSubscriptionSavePercent();
    $('.subscription-toggle .toggle-text strong').each(function () {
      $(this).text('Subscribe & save an extra ' + pct + '%');
    });
  }

  function readDataCents($el, key) {
    var v = parseInt($el.attr('data-' + key), 10);
    return isNaN(v) ? 0 : v;
  }

  function resolveCompareCents(priceCents, compareCents, listCompareCents) {
    if (compareCents > priceCents) return compareCents;
    if (listCompareCents > priceCents) return listCompareCents;
    return 0;
  }

  function ensureComparePriceEl($label) {
    var $wrapper = $label.find('.price-wrapper');
    if (!$wrapper.length) return $();
    var $compareEl = $wrapper.find('.compare-price');
    if (!$compareEl.length) {
      $compareEl = $('<span class="compare-price"></span>');
      $wrapper.append($compareEl);
    }
    return $compareEl;
  }

  /**
   * Updates every "Choose your quantity" row: subscription vs one-time prices,
   * compare-at, and Save % (10/20/30 by pack when one-time; subscription % when subscribed).
   */
  function updateEverything() {
    var isChecked = $('#subscriptionToggle').is(':checked');
    var hasSubToggle = $('#subscriptionToggle').length > 0;
    var subSavePct = getSubscriptionSavePercent();

    updateSubscriptionToggleLabel();

    $('input.choose-your-quantity').each(function () {
      var $inp = $(this);
      var price = readDataCents($inp, 'price');
      var compare = readDataCents($inp, 'compare');
      var subPrice = readDataCents($inp, 'sub-price');
      var subCompare = readDataCents($inp, 'sub-compare');
      var listCompare = readDataCents($inp, 'list-compare');

      var $label = $('label[for="' + $inp.attr('id') + '"]');
      if (!$label.length) return;

      var finalPrice;
      var finalCompare = 0;
      var showBadge = false;
      var badgeText = '';
      var $compareEl = ensureComparePriceEl($label);

      if (hasSubToggle && isChecked && subPrice > 0) {
        finalPrice = subPrice;
        finalCompare = resolveCompareCents(finalPrice, subCompare, listCompare);
        if (finalCompare <= finalPrice) {
          finalCompare = resolveCompareCents(finalPrice, compare, listCompare);
        }
        // Hide row % when subscribed — toggle uses "extra X%" to avoid stacking confusion with bulk savings.
        showBadge = false;
        badgeText = '';
      } else {
        finalPrice = price;
        finalCompare = resolveCompareCents(finalPrice, compare, listCompare);
        var qtySavePct = getQuantitySavePercent($inp);
        showBadge = finalCompare > finalPrice;
        if (showBadge) {
          badgeText = qtySavePct > 0 ? 'Save ' + qtySavePct + '%' : '';
          if (!badgeText) {
            badgeText = 'Save ' + Math.round((finalCompare - finalPrice) * 100 / finalCompare) + '%';
          }
        }
      }

      finalPrice = Math.round(finalPrice);
      finalCompare = Math.round(finalCompare);

      $label.find('.price').html(formatMoney(finalPrice));

      if (finalCompare > finalPrice && $compareEl.length) {
        $compareEl.html(formatMoney(finalCompare)).prop('hidden', false).show();
      } else if ($compareEl.length) {
        $compareEl.prop('hidden', true).hide();
      }

      var $badge = $label.find('.save-badge');
      if (showBadge && badgeText) {
        $badge.html(badgeText).show();
      } else {
        $badge.hide();
      }
    });

    var $selected = $('input.choose-your-quantity:checked');
    if ($selected.length) {
      var sellingPlanId = $selected.attr('data-selling-plan-id') || '';
      if (hasSubToggle && isChecked && sellingPlanId) {
        $('input[name="selling_plan"]').val(sellingPlanId);
      } else {
        $('input[name="selling_plan"]').val('');
      }
    }

    syncSubscriptionModeClass();
  }

  /** Keeps compare/save on pack rows hidden during SSR refresh when Subscribe is OFF (see custom.css). */
  function syncSubscriptionModeClass() {
    var $t = $('#subscriptionToggle');
    if (!$t.length) {
      document.documentElement.classList.remove('lumia-subscribe-on', 'lumia-subscribe-off');
      return;
    }
    var on = $t.is(':checked');
    document.documentElement.classList.toggle('lumia-subscribe-on', on);
    document.documentElement.classList.toggle('lumia-subscribe-off', !on);
  }

function getRequiredQty() {
  // Example 1: value is "3 Pack"
  let val = $('input.choose-your-quantity:checked').val() || '';
  let num = parseInt(val.replace(/\D/g, ''), 10);

  // Example 2 (better): use data attribute if available
  // let num = parseInt($('input.choose-your-quantity:checked').data('option-value-id'), 10);

  return isNaN(num) ? 0 : num;
}
 function updateFlavourQty($el) {

  //  ALWAYS get required qty from pack selector
  var requiredQty = getRequiredQty();

  //  DO NOT derive requiredQty from $el.val() anymore

  if (requiredQty > 0) {

    // If user clicked pack option → sync all flavour qty
    if ($el && $el.hasClass('choose-your-quantity')) {
      // $('input.flavor:checked')
      //   .next('label')
      //   .find('.custom-qty-box.flavour-box-only input')
      //   .val(requiredQty)
      //   .trigger('change');
    }

    // One line item = one pack variant (1/3/6 boxes). Do not multiply cart qty by pack size.
    $('.product-form__input.product-form__quantity input.quantity__input')
      .val(1)
      .trigger('change');

    //  VALIDATION
    var totalFlavourQty = 0;

    $('.custom-qty-box.flavour-box-only input').each(function () {
      totalFlavourQty += parseInt($(this).val()) || 0;
    });

    var $addToCart = $('.button.product-form__submit');

  //  console.log('Required:', requiredQty, 'Selected:', totalFlavourQty);
    
    if (totalFlavourQty === requiredQty && requiredQty > 0) {
      $addToCart.prop('disabled', false);

      if ($addToCart.next('.custom-msg').length) {
        $addToCart.next('.custom-msg').text("Your Mix Is Ready!");
      } else {
        $addToCart.after('<p class="custom-msg">Your Mix Is Ready!</p>');
      }

    } else {
      $addToCart.prop('disabled', true);

      if ($addToCart.next('.custom-msg').length) {
        $addToCart.next('.custom-msg').text("Your Mix Is Not Ready!");
      } else {
        $addToCart.after('<p class="custom-msg not-ready">Your Mix Is Not Ready!</p>');
      }
    }

    $('span.dynamic-qty.required').text(requiredQty);
    $('span.dynamic-qty.changeable').text(totalFlavourQty);

  }
}

  $(document).on('change', '#subscriptionToggle', function () {
    updateEverything();
    validateBundle();
  });
 
$(document).on('change', 'input.choose-your-quantity', function () {
  const $this = $(this);

  //  RESET ALL FLAVORS FIRST
  $('.flavor-card').each(function () {
    $(this).find('.qty').val(0);
    $(this).find('.flavor-checkbox').prop('checked', false);
    $(this).removeClass('active');
  });

  updateEverything();

  setTimeout(function () {
    updateEverything();
    updateFlavourQty($this);
    validateBundle(); //  important to reset button state too
  }, 1900);
});

  setTimeout(function () {
    $('button.product-form__submit').prop('disabled', true);
      updateEverything();

      var $selected = $('input.choose-your-quantity:checked');
      if ($selected.length) {
        updateFlavourQty($selected);
      }
    }, 100);
    document.addEventListener('variant:change', function () {
      updateEverything();
      validateBundle();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        requestAnimationFrame(function () {
          updateEverything();
          validateBundle();
        });
      });
    }



  var $default = $('label.custom-option.by-default-selected');
  var inputId = $default.attr('for');

  if (inputId) {
    var $input = $('#' + inputId);
    $input.prop('checked', true);

    // No bubbling, no scroll, no side effects
    $input.triggerHandler('change');
  }

  $(document).on("click", ".quick-add__submit", function () {

  var ss = $('.custom-judgeme-append').html();
  setTimeout(function () {
  $('.quick-add-modal__content-info product-info').find('.jdgm-widget.jdgm-all-reviews-text').html(ss);
    }, 2000);
  });

// Add +/1 To QTY Inputs



function getFlavorData($card) {
  const checkbox = $card.find('.flavor-checkbox');
  const flavor = checkbox.data('flavor');
  const qty = parseInt($card.find('.qty').val()) || 0;
  const checked = checkbox.prop('checked');

  return {
    flavor: flavor,
    qty: qty,
    checked: checked
  };
}


// $(document).on('click', '.flavor-card', function (e) {
//   e.preventDefault();
//   e.stopPropagation();

//   const $card = $(this);
//   const $input = $card.find('.qty');
//   const $checkbox = $card.find('.flavor-checkbox');

//   let currentQty = parseInt($input.val()) || 0;
//   let totalQty = getTotalQty();
//   let limit = getRequiredQty();

//   //  If already selected → do NOTHING (no uncheck allowed via card)
//   if (currentQty > 0) {
//     return;
//   }

//   //  If limit reached → do NOTHING
//   if (totalQty >= limit) {
//     return;
//   }

//   //  Otherwise behave like "+"
//   let newVal = currentQty + 1;

//   $input.val(newVal);

//   $checkbox.prop('checked', true);
//   $card.addClass('active');

//   validateBundle();
// });
$(document).on('change', '.flavor-checkbox', function () {
  const $checkbox = $(this);
  const $card = $checkbox.closest('.flavor-card');
  const $input = $card.find('.qty');

  let limit = getRequiredQty();
  let total = getTotalQty();

  //  IF USER IS TRYING TO CHECK
  if ($checkbox.is(':checked')) {

    //  BLOCK if limit reached
    if (total >= limit) {
      $checkbox.prop('checked', false); // revert selection
      return;
    }

    //  allow selection
    if (parseInt($input.val()) === 0) {
      $input.val(1);
    }

    $card.addClass('active');
  }

  //  IF USER UNCHECKS
  else {
    $input.val(0);
    $card.removeClass('active');
  }

  validateBundle();
  lockCheckboxState();
});
//  Get total qty
function getTotalQty() {
  let total = 0;
  $('.flavor-card').each(function () {
    total += parseInt($(this).find('.qty').val()) || 0;
  });
  return total;
 

}

//  Validate bundle
function validateBundle() {
  let totalQty = getTotalQty();
  let limit = getRequiredQty();
    $('span.dynamic-qty.changeable').text(totalQty);
  const $addToCart = $('button.product-form__submit');
  const $incButtons = $('.qty-button.inc');

  if (totalQty === limit && totalQty > 0) {
    $addToCart.prop('disabled', false);
     if ($addToCart.next('.custom-msg').length) {
        $addToCart.next('.custom-msg').text("Your Mix Is Ready!");
      } else {
        $addToCart.after('<p class="custom-msg">Your Mix Is Ready!</p>');
      }
    $incButtons.prop('disabled', true);
  } else {
    $addToCart.prop('disabled', true);
    $incButtons.prop('disabled', false);

    if ($addToCart.next('.custom-msg').length) {
      $addToCart.next('.custom-msg').text("Your Mix Is Not Ready!");
    } else {
      $addToCart.after('<p class="custom-msg">Your Mix Is Not Ready!</p>');
    }
  }
}

function lockCheckboxState() {
  let total = getTotalQty();
  let limit = getRequiredQty();

  if (total >= limit) {
    $('.flavor-card').each(function () {
      let qty = parseInt($(this).find('.qty').val()) || 0;
      let $checkbox = $(this).find('.flavor-checkbox');

      //  force correct state
      $checkbox.prop('checked', qty > 0);
      $(this).toggleClass('active', qty > 0);
    });
  }
}

//  SINGLE SOURCE: BUTTON CLICK
$(document).on("click", ".qty-button", function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $btn = $(this);
  const $card = $btn.closest('.flavor-card');
  const $input = $card.find('.qty');
  const $checkbox = $card.find('.flavor-checkbox');

  let oldVal = parseInt($input.val()) || 0;
  let total = getTotalQty();
  let limit = getRequiredQty();

  let newVal = oldVal;

  // ➕ INCREMENT
  if ($btn.hasClass('inc')) {
    if (total >= limit) {
      lockCheckboxState(); //  enforce state
      return;
    }

    newVal = oldVal + 1;

    $checkbox.prop('checked', true);
    $card.addClass('active');
  }

  // ➖ DECREMENT
  if ($btn.hasClass('dec')) {
    if (oldVal === 0) return;

    newVal = oldVal - 1;

    if (newVal === 0) {
      $checkbox.prop('checked', false);
      $card.removeClass('active');
    } else {
      $checkbox.prop('checked', true);
      $card.addClass('active');
    }
  }

  $input.val(newVal);

  validateBundle();
  lockCheckboxState(); //  ALWAYS enforce after update
});
$(document).on('click', '.flavor-info', function (e) {
  e.preventDefault();
});
//  STOP bubbling
$(document).on("click", ".qty, .qty-button", function (e) {
  e.stopPropagation();
});

$(document).on('click', '.product-form__submit', function (e) {
 // e.preventDefault();

  let properties = {};
  
  $('.flavor-card').each(function () {
    const $card = $(this);
    const $checkbox = $card.find('.flavor-checkbox');
    const qty = parseInt($card.find('.qty').val()) || 0;

    // only selected items
    if ($checkbox.is(':checked') && qty > 0) {
      const name = $card.find('.flavor-name').text().trim() || $checkbox.val();

      properties[name] = qty;
    }
  });

  console.log("Line Item Properties:", properties);

  // attach to form input
  const $form = $(this).closest('form');

  // remove old properties if any
  $form.find('input[name^="properties"]').remove();

  // append new properties
  Object.keys(properties).forEach(key => {
    $form.append(
      `<input type="hidden" name="properties[${key}]" value="${properties[key]}">`
    );
  });

  // submit form after injection
  //$form.submit();
    $('input.quantity__input').val(1);
});
$(document).on('keydown paste input', 'input.qty', function (e) {
  e.preventDefault();
});
$(document).on('keydown paste input', 'input.quantity__input', function (e) {
  e.preventDefault();
});

validateBundle();
// ============================

// Custom code for Product QTY

// =============================

});